import { Typography } from '@cmg/design-system';

export type Props = Readonly<{
  updatedAt: string;
  updatedBy: string;
}>;

const UpdatedAtText: React.FC<Props> = ({ updatedAt, updatedBy }) => {
  return (
    <Typography variant="highlight1" data-testid="update-at-message">
      {`Update at ${updatedAt} by ${updatedBy}`}
    </Typography>
  );
};

export default UpdatedAtText;
